import { dateTime } from "@gravity-ui/date-utils";
import dayjs from "@gravity-ui/date-utils/build/dayjs";
import { DATE_VIEW_FORMAT } from "./constants";
/** Выделение из даты ТОЛЬКО времени и преобразование его в минуты */
export var dateTimeConvertToMinutes = function (time) {
    var resultHours = time.hour();
    var resultMinutes = time.minute();
    return resultMinutes + resultHours * 60;
};
/** Преобразование минут в строку часы:минуты */
export var timeConvertToFormattedString = function (minutes) {
    var hours = Math.floor(minutes / 60);
    var mins = minutes % 60;
    return "".concat(hours.toString().padStart(2, "0"), ":").concat(mins
        .toString()
        .padStart(2, "0"));
};
/** Преобразование минут в формат даты gravity */
export var timeConvertToDateTime = function (minutes) {
    return minutes !== null
        ? dateTime({
            input: timeConvertToFormattedString(minutes),
            format: "HH:mm",
        })
        : dateTime();
};
export var dateToStringView = function (date) {
    return dayjs(date).format(DATE_VIEW_FORMAT);
};
